import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Parameter } from '../models/parameter.model';
import * as fromCountryParametersAction from '../actions/country-parameters.action';

export interface State extends EntityState<Parameter> {
    selectedParameterId: string | null;
}

export const adapter: EntityAdapter<Parameter> = createEntityAdapter<Parameter>({
    selectId: (parameter: Parameter) => parameter.ParameterGroup + '-' + parameter.parameterCode,
    sortComparer: false,
});

const initialState: State = adapter.getInitialState({
    selectedParameterId: null,
});

export function reducer(state = initialState, action: fromCountryParametersAction.Actions): State {
    switch (action.type) {
        case fromCountryParametersAction.ActionTypes.FETCH_COUNTRY_PARAMETERS: {
            return state;
        }
        case fromCountryParametersAction.ActionTypes.FETCH_COUNTRY_PARAMETERS_SUCCESSS: {
            return adapter.addMany(action.payload, adapter.removeAll(state));
        }
        case fromCountryParametersAction.ActionTypes.CLEAR_COUNTRY_PARAMETERS: {
            return adapter.removeAll(state);
        }
        default: {
            return state;
        }
    }
}

export const getSelectedParameterId = (state: State) => state.selectedParameterId;

export const getParametersEntities = (state: State) => state.entities;

export const getCountryParameters =  (state: State) => {
    const parameters: Parameter[] = Object.keys(state.entities).map(i => state.entities[i]);
    return parameters;
};
